export const VALIDATE_DOCUMENT = 'VALIDATE_DOCUMENT';
export const REQUEST_DOCUMENTS_TO_VALIDATE = 'REQUEST_DOCUMENTS_TO_VALIDATE';
export const SET_DOCUMENTS_TO_VALIDATE = 'SET_DOCUMENTS_TO_VALIDATE';
export const SET_COUNT = 'SET_COUNT';